import { type ObjectValuesUnionType } from '../../utils/typing';

// Multiview Actions
export const MultiviewActionTypes = Object.freeze({
  SET_DISPLAY_MODE: 'multiview/setDisplayMode',
  ADD_MATCH: 'multiview/addMatch',
  DEL_MATCH: 'multiview/delMatch',
  SET_ITEM_PER_LINE: 'multiview/setItemPerLine',
  SET_SHOW_MATCH_LIST: 'multiview/showMatchList',
  SET_DISPLAY_OPTIONS: 'multiview/setDisplayOptions',
  SAVE_TO_STORAGE: 'multiview/saveToStorage',
  SET_USER_OPTION: 'multiview/setUserOption',
  SET_SCROLL_TO_HEADER: 'multiview/setScrollToHeader',
});

export type MultiviewActionType = ObjectValuesUnionType<typeof MultiviewActionTypes>;
